import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const InnovasjonNorge = ({ title, titleId, desc, descId }: SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 96 96"
    aria-labelledby={titleId}
    aria-describedby={descId}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#ED0000"
      fillRule="evenodd"
      d="M0 76.8h19.2V96H0zM76.8 0H96v96H76.8l-48-57.6h22.413L76.8 68.668z"
      clipRule="evenodd"
    />
  </svg>
);
export default InnovasjonNorge;
